import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getSanctionInfo } from 'services/riskConsiderationService';
import { SanctionsInfo } from 'types/RiskConsiderationsConfig';

export const useFetchSanctionsInfo = (partnerUid: string, enable: boolean) => {
  return useQuery<SanctionsInfo, AxiosError>({
    queryKey: ['useFetchSanctionsInfo', partnerUid],
    queryFn: () => getSanctionInfo(partnerUid),
    gcTime: 0,
    enabled: enable,
  });
};
